import ContentsCard from "features/無料占いコンテンツ/components/organisms/ContentsCard";
import { Heading } from "features/無料占いコンテンツ/components/atoms/Heading";
import { Text } from "features/無料占いコンテンツ/components/atoms/Text";
import SectionTitle from "features/無料占いコンテンツ/components/atoms/SectionTitle";
import { BreadCrumb } from "features/無料占いコンテンツ/components/molecules/BreadCrumb";
import Layout from "components/layout";
import { ReactNode } from "react";
import { AppHeader } from "components/layout/Header";
import Body from "features/無料占いコンテンツ/components/layout/Body";
import { useFreeFortuneContentList } from "repositories/hooks/useFreeFortuneContentList";
import { Loading } from "shared/components/templates/Loading";
import { MediaNav } from "features/media/components/atoms/MediaNav";
import { Pager } from "shared/components/molecules/Pager";
import { useRouter } from "next/router";

const 無料占いコンテンツ = () => {
  const { query } = useRouter();
  const { freeFortuneContents, meta, isLoading } = useFreeFortuneContentList({
    page: query.page as string,
  });

  return (
    <Body tw="px-4">
      <BreadCrumb tw="pt-2.5 px-4" />
      <div tw="my-5">
        <Heading tw="my-5">無料占い</Heading>
        <Text tw="my-5">
          国内最大級の占いサービスMIROR(ミラー)が提供する完全無料の占いです。当たると口コミで話題の人気占い師が監修提供しており、タロット占いや生年月日占い、四柱推命、霊視や透視を使った占いコンテンツなどを完全無料で豊富に提供しております。
        </Text>
        <SectionTitle>新着無料占い</SectionTitle>
      </div>
      {isLoading ? (
        <Loading loading />
      ) : (
        <ul>
          {freeFortuneContents.map((content) => (
            <ContentsCard key={content.id} freeFortuneContent={content} />
          ))}
        </ul>
      )}
      <Pager currentPage={meta?.page} totalPages={meta?.pages} tw="my-6" />
    </Body>
  );
};

無料占いコンテンツ.getLayout = (page: ReactNode) => {
  return (
    <Layout header={<AppHeader />}>
      <MediaNav />
      {page}
    </Layout>
  );
};

export default 無料占いコンテンツ;
